module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_null.f9c8ee42.png";